import { FC } from "react";

import { Chip } from "./Chip";
import { IconText } from "./IconText";
import { TrackedLink } from "./TrackedLink";

import { t } from "i18n/i18n";
import { ScoreIcon } from "mds/icons";
import { type TrackingProps } from "utils/amplitude";

type OutcomeChipPropType = TrackingProps & {
  title: string;
  score?: number | null;
  selected?: boolean;
  to?: string;
  onClick?: () => void;
  className?: string;
  floor?: boolean;
  role?: "heading" | "listitem";
};

export const OutcomeChip: FC<OutcomeChipPropType> = ({
  score,
  title,
  to,
  onClick,
  selected,
  className,
  eventName,
  floor = false,
  eventProps,
  role,
}) => {
  const hasScore = score !== undefined && score !== null;

  return (
    <Chip
      as={to ? TrackedLink : onClick ? "button" : "div"}
      className={className}
      eventName={eventName}
      eventProps={eventProps}
      isSelected={selected}
      kind="outcome"
      to={to}
      onClick={onClick}
    >
      <IconText
        className="gap-1.5"
        iconEnd={
          hasScore ? (
            <ScoreIcon
              aria-label={t("outcomes.average_score", { score })}
              floor={floor}
              role={role}
              size="s"
              value={score}
            />
          ) : undefined
        }
        text={
          <span aria-label={t("outcomes.outcome_label", { title })} role={role}>
            {title}
            {hasScore ? " " : null}
          </span>
        }
      />
    </Chip>
  );
};
